import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@services/notification.service';
import { ExamineesService } from '../../services/examinees.service';
import { UsersService } from '../../services/users.service';
import { examineeEditUuid } from '../examiness.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-examinee',
  templateUrl: './edit-examinee.component.html',
  styleUrls: ['./edit-examinee.component.scss'],
})
export class EditExamineeComponent implements OnInit {
  examineeDetailsForm: FormGroup;
  duplicateDataFlag = false;
  action = 'createUser';
  examineeuuid: number;
  isAddMode: boolean;
  examineeData: any;
  oldEmailId: any;
  isEmailNotValid: boolean = false;
  isDisabled: boolean = false;
  disabled: boolean = true
  statusList: any;
  inValidPhone: boolean = false;
  constructor(
    private usersService: UsersService,
    private router: Router,
    private webErrorService: WebErrorService,
    private actRoute: ActivatedRoute,
    private examineesService: ExamineesService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    // private ,
    @Inject(MAT_DIALOG_DATA) private examineeEditUuid: examineeEditUuid
  ) {

  }

  ngOnInit(): void {
    this.examineesService.getStatusList().subscribe((statusList) => { this.statusList = statusList.data;})
    // this.examineeuuid = this.actRoute.snapshot.params['id'];
    this.examineeuuid = this.examineeEditUuid?.examineeuuId;
    this.isAddMode = !this.examineeuuid;

    this.examineeDetailsForm = new FormGroup({
      firstName: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/),
      ]),
      lastName: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/),
      ]),
      phone: new FormControl(null, [
        // Validators.required,
        Validators.minLength(5),
        Validators.maxLength(24),
        Validators.pattern(/^(?:\+?(\d{0,3}))?[- \(]*(\d{1,9})[-. \/)]*(\d{1,9})[-. \/]*(\d{1,9})*[-. \/]*(\d{1,9})(?: *x(\d))?$/
        ),
      ]),
      emailId: new FormControl(null, [
        Validators.required,
        Validators.minLength(7),
        Validators.maxLength(124),
        Validators.pattern(/^[a-zA-Z0-9]+([.]?[_]?[-]?[a-zA-Z0-9])*@[a-zA-Z0-9]+([\-\.]?[a-zA-Z0-9]+)+\.[A-Za-z]{2,4}$/),
      ]),
      status: new FormControl('true', [Validators.required]),
    });

    // this.examineeDetailsForm.controls['emailId'].disable();

    this.examineesService.getExamineeByID(this.examineeuuid)?.subscribe((resData) => {
      this.examineeData = resData?.data;
      this.oldEmailId = this.examineeData.emailId;
      this.getEmailDetails();
      this.examineeDetailsForm.controls['firstName'].setValue(
        this.examineeData.firstName.trim()
      );
      this.examineeDetailsForm.controls['lastName'].setValue(
        this.examineeData.lastName.trim()
      );
      this.examineeDetailsForm.controls['phone'].setValue(
        this.examineeData.phone
      );
      this.examineeDetailsForm.controls['emailId'].setValue(this.examineeData.emailId.trim());
      this.examineeDetailsForm.controls['status'].setValue(
        this.examineeData.active
      );
    },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    // this.examineeDetailsForm.get('emailId')?.disable();
  }

  getEmailDetails() {
    this.examineeDetailsForm.controls.emailId.valueChanges.subscribe(data => {
      if (this.oldEmailId !== data) {
        this.isEmailNotValid = true;
        this.notificationService.warn('Cannot change Email');
      } else {
        this.isEmailNotValid = false;
      }
    })
  }

  get f() {
    return this.examineeDetailsForm.controls;
  }

  onClickOutside(event: any) {
    if(event) {
      this.inValidPhone = true;
    } else {
      this.inValidPhone = false;
    }
  }

  changeField(event: KeyboardEvent) { this.webErrorService.customErrors(this.translate.instant('examinee.updateExaminee.errMsg1'), true, 'warn'); if (event.key === ' ' && !this.examineeDetailsForm.value.emailId.length) event.preventDefault(); }

  editExamineeDetails() {

    const apiData = {
      // collectioId: this.collectionId,
      firstName: this.examineeDetailsForm.value.firstName.trim(),
      lastName: this.examineeDetailsForm.value.lastName.trim(),
      phone: this.examineeDetailsForm.value.phone == '' ? null : this.examineeDetailsForm.value.phone,
      active: this.examineeDetailsForm.value.status,
    };


    this.examineesService.editExaminee(apiData, this.examineeuuid).subscribe(
      (resData) => {
        this.examineesService.getExaminees()?.subscribe(resData => {
          this.examineesService.newExamineeList(resData);
        },
          (error: any) => {
            this.webErrorService.handleAPIErrors(error);
          });
        this.notificationService.success(resData?.message);
        this.router.navigate(['/examinees']);
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
  }

  onTestNameControlFocus(): void {
    this.duplicateDataFlag = false;
  }

  navigateToLandingPage() {
    this.router.navigate(['/examinees']);
  }
}

